export default "__VITE_ASSET__C_Sr6EHj__"